import { NgModule, Component, OnInit, OnDestroy } from '@angular/core';
import { FormlyModule, FormlyFieldConfig, FieldType, FormlyBootstrapModule, Field, FormlyField, FieldWrapper, FormlyAttributes } from 'ng-formly';
import { EntityrecordApi, EntityApi, EntityfieldApi } from '../../sdk/services/custom';
import { Router, ActivatedRoute } from '@angular/router';
import { LoopBackFilter } from '../../sdk/models/';
import * as _ from "lodash";
import { PlatformApp } from '../../services/app.service';
import { getFieldFromArray, isNotEmpty, valueLabel } from '../../utils/util';

@Component({
	selector: 'formly-readonly-field',
	template: `
     <input [type]="type" [formControl]="formControl" class="form-control" [id]="id"
      [formlyAttributes]="field" [ngClass]="{'form-control-danger': valid}" readonly>
  `,
})

export class ReadonlyField extends FieldType implements OnInit, OnDestroy {

	private formulae = [];
	private modelValues = [];

	get type() {
		return this.to.type || 'text';
	}

	ngOnInit() {
		if (!this.form['subscriptions'])
			this.form['subscriptions'] = [];

		// Adding new Controls to hold formControls for hidden fields
		if (!this.form['newcontrols'])
			this.form['newcontrols'] = {};
		for (var key in this.form.controls) {
			this.form['newcontrols'][key] = this.form.controls[key];
		}

		if (this.field['formulae']) {
			this.formulae = this.field['formulae'];
			if (this.field.formControl) {
				this.addWatcher(this.field.formControl);
			}
		}
	}

	private addWatcher(formControl) {
		this.form['subscriptions'].push(formControl.valueChanges.subscribe((updatedValue: any) => {
			for (var i = 0; i < this.formulae.length; i++) {
				var formula = this.formulae[i];
				if (this.setModelValues(formula['fields'], updatedValue)) {
					this.setResults(formula['results'], PlatformApp.processData(formula['formula'], this.modelValues));
				}
			}
		}));
	}

	private setModelValues(fieldArray, updatedValue) {
		var requiredFieldsExist = true;
		this.modelValues = [];
		for (var j = 0; j < fieldArray.length; j++) {
			if (!this.model[fieldArray[j]]) {
				requiredFieldsExist = false;
				break;
			} else {
				if (fieldArray[j] == this.field.key) {
					this.modelValues.push(updatedValue);
				} else {
					this.modelValues.push(this.model[fieldArray[j]]);
				}
			}
		}
		return requiredFieldsExist;
	}

	private setResults(resultArray, value): void {
		for (var i = 0; i < resultArray.length; i++) {
			var resultField = resultArray[i];
			if (this.form.controls[resultField]) {
				this.form.controls[resultField].setValue(value);

				if (this.form['newcontrols'][resultField] && !this.model[resultField]) {
					this.form.setControl(resultField, this.form['newcontrols'][resultField]);
					this.form.controls[resultField].setValue(value);
				}
			} else {
				if (this.form['newcontrols'][resultField]) {
					this.form.addControl(resultField, this.form['newcontrols'][resultField]);
					this.form.controls[resultField].setValue(value);
				} else {
					this.model[resultField] = value;
				}
			}
		}
	}

	ngOnDestroy() {
	}
}



// WEBPACK FOOTER //
// ./src/app/shared/components/fields/readonlyfield.ts